import script from "./PromptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptForm.vue?vue&type=script&setup=true&lang=js"

import "./PromptForm.vue?vue&type=style&index=0&id=879f6946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-879f6946"]])

export default __exports__